import axios from 'axios'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/tailwind.css';
import './plugins'
import 'animate.css';

import config from '../../load-config';

config.then((configValues) => {
  axios.defaults.baseURL = `${configValues.VUE_APP_API_URL}`;

  const localConfig = {
    VUE_APP_API_URL: `${configValues.VUE_APP_API_URL}`,
    VUE_APP_BASE_URL: `${configValues.VUE_APP_BASE_URL}`,
    VUE_APP_APP_URL: `${configValues.VUE_APP_APP_URL}`,
    VUE_APP_PUSHER_APP_KEY: `${configValues.VUE_APP_PUSHER_APP_KEY}`,
    VUE_APP_PUSHER_APP_CLUSTER: `${configValues.VUE_APP_PUSHER_APP_CLUSTER}`,
    VUE_APP_FIREBASE_API_KEY: `${configValues.VUE_APP_FIREBASE_API_KEY}`,
    VUE_APP_FIREBASE_AUTH_DOMAIN: `${configValues.VUE_APP_FIREBASE_AUTH_DOMAIN}`,
    VUE_APP_FIREBASE_PROJECT_ID: `${configValues.VUE_APP_FIREBASE_PROJECT_ID}`,
    VUE_APP_FIREBASE_STORAGE_BUCKET: `${configValues.VUE_APP_FIREBASE_STORAGE_BUCKET}`,
    VUE_APP_FIREBASE_MESSAGING_SENDER_ID: `${configValues.VUE_APP_FIREBASE_MESSAGING_SENDER_ID}`,
    VUE_APP_FIREBASE_APP_ID: `${configValues.VUE_APP_FIREBASE_APP_ID}`,
    VUE_APP_FIREBASE_MEASUREMENT_ID: `${configValues.VUE_APP_FIREBASE_MEASUREMENT_ID}`,
    VUE_APP_FIREBASE_DATABASE_URL: `${configValues.VUE_APP_FIREBASE_DATABASE_URL}`,
    VUE_APP_FIREBASE_SERVER_KEY: `${configValues.VUE_APP_FIREBASE_SERVER_KEY}`,
    VUE_APP_ZOOMOAUTH_CLIENT_ID: `${configValues.VUE_APP_ZOOMOAUTH_CLIENT_ID}`,
    VUE_APP_STRIPE_CLIENT_ID: `${configValues.VUE_APP_STRIPE_CLIENT_ID}`,
    VUE_APP_STRIPE_SECRET_KEY: `${configValues.VUE_APP_STRIPE_SECRET_KEY}`,
    VUE_APP_GOOGLE_CLIENT_ID: `${configValues.VUE_APP_GOOGLE_CLIENT_ID}`,
    VUE_APP_GOOGLE_CLIENT_SECRET: `${configValues.VUE_APP_GOOGLE_CLIENT_SECRET}`,
    VUE_APP_ZOOM_SIGNATURE_ENDPOINT: `${configValues.VUE_APP_ZOOM_SIGNATURE_ENDPOINT}`,
    VUE_APP_TIME_TO_JOIN_IN_MINUTES: `${configValues.VUE_APP_TIME_TO_JOIN_IN_MINUTES}`,
    VUE_APP_TOP_BANNER_MESSAGE: `${configValues.VUE_APP_TOP_BANNER_MESSAGE}`,
    VUE_APP_TRAINER_TUTORIAL_URL: `${configValues.VUE_APP_TRAINER_TUTORIAL_URL}`,
    VUE_APP_ATTENDEE_TUTORIAL_URL: `${configValues.VUE_APP_ATTENDEE_TUTORIAL_URL}`,
    
  };
  window.config = localConfig;

  Vue.config.productionTip = false

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
});